import React from 'react';
import { ItemPath } from '../../../../order.schema';
import ResourceSection from '../../Product/ResourceSection';

interface FormResourceProps {
  itemPath: ItemPath;
}

export const FormResource: React.FC<FormResourceProps> = ({ itemPath }) => {
  return (
    <>
      <ResourceSection itemPath={itemPath} />
    </>
  );
};